export default {"src":"/_next/static/media/3.b1bea629.svg","height":37,"width":37};